module.exports = __webpack_public_path__ + "img/gallery-06.2b8a2998.jpg";